import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';

@Component({
  selector: 'app-specialist-change-password',
  templateUrl: './specialist-change-password.component.html',
  styleUrls: ['./specialist-change-password.component.css']
})
export class SpecialistChangePasswordComponent {

  isSubmitDisabled = false;

  fields = {
    strOldPassword: '',
    strNewPassword: '',
    strNewPasswordRepeat: ''
  };

  unSubscribeAll$ = new Subject<void>();

  constructor(
    private accountService: AccountService,
    private otherService: OtherService,
    private router: Router,
  ) { }

  submit(ngForm: NgForm) {
    if (this.fields.strNewPassword !== this.fields.strNewPasswordRepeat) {
      this.accountService.toastSwal('error', 'تکرار رمز عبور اشتباه است');
      ngForm.form.markAsPristine();
      return;
    }

    if (ngForm.invalid || ngForm.pristine || this.isSubmitDisabled) {
      return;
    }
    this.isSubmitDisabled = true;

    const model = {
      ...this.fields,
      iSystemUser: this.otherService.specialistUser.iSystemUser,
      strSession: this.otherService.specialistUser.strSession
    };

    this.accountService.specialistChangePassword(model).pipe(
      catchError(() => of(false)),
      takeUntil(this.unSubscribeAll$),
    ).subscribe((response: string | false) => {
      this.isSubmitDisabled = false;
      ngForm.form.markAsPristine();

      if (response) {
        let result = JSON.parse(response);
        if (Array.isArray(result)) result = result[0];

        if (result?.ISSessionExpired == true) {
          this.otherService.logout();
          this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
          this.accountService.toastSwal('error', 'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید')
          return;
        }

        if (result.iResult === 0) {
          return this.accountService.toastSwal('error', result.strError);
        }

        this.router.navigateByUrl('/home');
        this.accountService.toastSwal('success', 'عملیات با موفقیت انجام شد');
      } else {
        this.accountService.toastSwal('error', 'خطایی رخ داد');
      }
    });
  }

  unSubscribeAll(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }

  ngOnDestroy(): void {
    this.unSubscribeAll();
  }

}
